export const translation = {
  "nav.home": "Home",
  "nav.spreadsheet": "Spreadsheet",
  "nav.guides": "Guides",
  "nav.shipping": "Shipping",
  "nav.qc": "QC",
  "nav.reviews": "Reviews",
  "nav.comparisons": "Comparisons",
  "nav.safety": "Safety",
  "nav.categories": "Categories",
  "nav.language": "Language",
  "nav.about": "About",
  "nav.contact": "Contact",
  "nav.buyingGuide": "Buying Guide",
  "nav.faq": "FAQ",
  "hero.title": "AllChinaBuy Spreadsheet — Your Complete Guide to Products, Sellers, QC & Shipping",
  "hero.subtitle": "Find Better Products with the AllChinaBuy Spreadsheet",
  "hero.description": "The AllChinaBuy Spreadsheet is a practical starting point for discovering products, researching sellers and understanding the buying process. Explore product lists, seller information, QC resources, shipping guides and useful tips in one organized resource.",
  "hero.cta.primary": "Explore the AllChinaBuy Spreadsheet",
  "hero.cta.secondary": "Browse the Complete Guide",
  "hero.trust": "Independent Resource • Updated Guides • Practical Buying Information",
  "cta.mainWebsite": "AllChinaBuy Spreadsheet",
  "cta.buyNow": "Buy It Now",
  "cta.visitMain": "Visit Main Website",
  "section.whatIs.title": "What Is the AllChinaBuy Spreadsheet?",
  "section.whatIs.description": "Looking for an easier way to research products and sellers? The AllChinaBuy Spreadsheet brings useful product information into one searchable resource. Instead of jumping between scattered links, use the spreadsheet to discover categories, compare options and continue your research with detailed guides.",
  "section.whatIs.cta": "Explore Spreadsheet Resources",
  "section.everything.title": "Everything You Need to Know About AllChinaBuy",
  "card.spreadsheet.title": "AllChinaBuy Spreadsheet",
  "card.spreadsheet.desc": "Discover products, categories and seller resources.",
  "card.review.title": "AllChinaBuy Review",
  "card.review.desc": "Understand the platform, features, buying process and important considerations.",
  "card.shipping.title": "AllChinaBuy Shipping Cost",
  "card.shipping.desc": "Learn about shipping methods, pricing factors, delivery times and ways to reduce unnecessary costs.",
  "card.warehouse.title": "AllChinaBuy Warehouse",
  "card.warehouse.desc": "Understand warehouse storage, QC photos, parcel preparation and shipping workflow.",
  "card.coupon.title": "AllChinaBuy Coupon",
  "card.coupon.desc": "Find current coupon information and understand how discounts may work.",
  "card.discount.title": "AllChinaBuy Discount Code",
  "card.discount.desc": "Explore available discount information and verify terms before using any code.",
  "card.legit.title": "AllChinaBuy Legit",
  "card.legit.desc": "Learn how to evaluate platform legitimacy, seller reliability and common buying risks.",
  "card.qc.title": "AllChinaBuy QC",
  "card.qc.desc": "Understand QC photos, product checks and what to review before shipping.",
  "card.shippingCost.title": "AllChinaBuy Shipping Cost",
  "card.shippingCost.desc": "Understand shipping rates, methods, weight factors and how to estimate costs.",
  "card.discountCode.title": "AllChinaBuy Discount Code",
  "card.discountCode.desc": "Find current discount codes and learn how to verify offers before use.",
  "card.sellers.title": "AllChinaBuy Sellers",
  "card.sellers.desc": "Learn how to identify trusted sellers and avoid unreliable vendors.",
  "card.comparison.title": "AllChinaBuy Comparison",
  "card.comparison.desc": "Compare AllChinaBuy with other agents across key dimensions.",
  "card.buyingGuide.title": "AllChinaBuy Buying Guide",
  "card.buyingGuide.desc": "A step-by-step guide from product search to final delivery.",
  "card.beginner.title": "AllChinaBuy for Beginners",
  "card.beginner.desc": "Everything first-time buyers need to know before their first order.",
  "card.payment.title": "AllChinaBuy Payment Guide",
  "card.payment.desc": "Understand payment methods, stages and safety best practices.",
  "card.refund.title": "AllChinaBuy Refund Guide",
  "card.refund.desc": "Learn how returns, disputes and refunds work on the platform.",
  "card.parcel.title": "AllChinaBuy Parcel Guide",
  "card.parcel.desc": "Packaging, consolidation and protection tips for international shipping.",
  "card.safetyGuide.title": "AllChinaBuy Safety Guide",
  "card.safetyGuide.desc": "Avoid scams, protect your account and buy with confidence.",
  "section.howTo.title": "How to Use the AllChinaBuy Spreadsheet",
  "step1": "Choose a product category.",
  "step2": "Open the relevant spreadsheet resource.",
  "step3": "Compare products and sellers.",
  "step4": "Review QC information and seller details.",
  "step5": "Check shipping information before ordering.",
  "step6": "Continue to the main website when you are ready.",
  "section.categories.title": "Popular AllChinaBuy Spreadsheet Categories",
  "category.shoes": "Shoes",
  "category.hoodies": "Hoodies/Sweaters",
  "category.tshirts": "T-Shirts",
  "category.jackets": "Jackets",
  "category.pants": "Pants/Shorts",
  "category.headwear": "Headwear",
  "category.sets": "Sets",
  "category.underwear": "Underwear/Underpants",
  "category.jersey": "Jersey",
  "category.accessories": "Accessories",
  "category.bags": "Bags",
  "category.belts": "Belts",
  "category.perfumes": "Perfumes",
  "category.other": "Other Stuff",
  "section.compare.title": "Compare Before You Buy",
  "section.shipping.title": "AllChinaBuy Shipping Guide",
  "section.shipping.description": "Shipping costs can vary depending on parcel weight, destination, shipping method, dimensions and current carrier conditions. Use our AllChinaBuy shipping resources to understand the main cost factors before preparing a parcel.",
  "section.shipping.cta": "View AllChinaBuy Shipping Cost Guide",
  "section.safety.title": "AllChinaBuy Safety Guide",
  "section.safety.description": "Buying through international marketplaces requires careful research. Learn how to verify sellers, review QC information, protect account details, understand shipping risks and recognize suspicious offers.",
  "section.safety.cta": "Read the AllChinaBuy Safety Guide",
  "section.guides.title": "Latest AllChinaBuy Guides",
  "section.faq.title": "Frequently Asked Questions",
  "faq.q1": "What is the AllChinaBuy Spreadsheet?",
  "faq.a1": "The AllChinaBuy Spreadsheet is an organized resource that compiles product information, seller details, and buying guides to help you research products more efficiently.",
  "faq.q2": "How does the AllChinaBuy Spreadsheet work?",
  "faq.a2": "The spreadsheet categorizes products by type, allowing you to browse categories, compare options, and find relevant sellers with detailed information.",
  "faq.q3": "Is AllChinaBuy legit?",
  "faq.a3": "AllChinaBuy is a buying agent platform. Like any international marketplace, it is important to research sellers, review QC photos, and understand the process before purchasing.",
  "faq.q4": "Is AllChinaBuy safe?",
  "faq.a4": "Safety depends on following best practices: verify sellers, review QC photos, use secure payment methods, and understand shipping and refund policies.",
  "faq.q5": "How much does AllChinaBuy shipping cost?",
  "faq.a5": "Shipping costs vary based on parcel weight, dimensions, destination, shipping method, and current carrier rates. Use our shipping guide for detailed information.",
  "faq.q6": "Where is the AllChinaBuy warehouse?",
  "faq.a6": "AllChinaBuy operates warehouses in China for receiving, inspecting, and forwarding parcels to international buyers.",
  "faq.q7": "How do AllChinaBuy coupons work?",
  "faq.a7": "Coupons and discount codes may be available for new users, seasonal promotions, or specific product categories. Always verify terms and expiration dates.",
  "faq.q8": "Where can I find an AllChinaBuy discount code?",
  "faq.a8": "Discount codes may be available through promotional emails, affiliate partners, or seasonal campaigns. Check our coupon guide for current information.",
  "faq.q9": "How do I check QC photos?",
  "faq.a9": "QC photos are taken at the warehouse before shipping. You can review them in your account to verify product condition, color, and details.",
  "faq.q10": "How can I find products through AllChinaBuy?",
  "faq.a10": "Use the spreadsheet to browse categories, or search directly by product name, category, or seller to find what you are looking for.",
  "finalCta.title": "Ready to Explore the AllChinaBuy Spreadsheet?",
  "finalCta.description": "Start with the spreadsheet, compare your options, learn how the buying process works, and use our guides to make more informed decisions.",
  "finalCta.button": "Explore AllChinaBuy Spreadsheet",
  "footer.spreadsheet": "AllChinaBuy Spreadsheet",
  "footer.guides": "Guides",
  "footer.reviews": "Reviews",
  "footer.shipping": "Shipping",
  "footer.qc": "QC",
  "footer.safety": "Safety",
  "footer.about": "About Us",
  "footer.contact": "Contact",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms & Conditions",
  "footer.disclaimer": "Disclaimer",
  "footer.disclaimerText": "This website is an independent informational resource and is not affiliated with AllChinaBuy unless explicitly stated.",
  "footer.mainCta": "Visit Main Website",
  "footer.copyright": "AllChinaBuy Spreadsheet. All rights reserved.",
  "breadcrumb.home": "Home",
  "article.readMore": "Read More",
  "article.published": "Published",
  "article.updated": "Updated",
  "article.author": "Editorial Team",
  "article.minRead": "min read",
  "seo.title.home": "AllChinaBuy Spreadsheet – Products, Sellers, QC & Shipping Guide",
  "seo.description.home": "Explore the AllChinaBuy Spreadsheet with product lists, trusted sellers, QC tips, shipping information, warehouse guides, reviews and practical buying resources.",
  "meta.keywords": "AllChinaBuy, AllChinaBuy Spreadsheet, AllChinaBuy review, AllChinaBuy shipping, AllChinaBuy coupon, AllChinaBuy discount code, AllChinaBuy warehouse, AllChinaBuy QC, AllChinaBuy legit, AllChinaBuy guide",
  "compare.feature": "Feature",
  "compare.allchinabuy": "AllChinaBuy",
  "compare.superbuy": "Superbuy",
  "compare.cssbuy": "CSSBuy",
  "compare.sugargoo": "Sugargoo",
  "compare.productDiscovery": "Product discovery",
  "compare.spreadsheet": "Spreadsheet resources",
  "compare.qcProcess": "QC process",
  "compare.warehouse": "Warehouse",
  "compare.shipping": "Shipping",
  "compare.payment": "Payment",
  "compare.beginnerFriendly": "Beginner friendly",
  "compare.support": "Support",
  "compare.research": "Research experience",
  "learnMore": "Learn More",
  "readGuide": "Read Guide",
  "backToHome": "← Back to Home",
  "safetyCenter.title": "Safety Center",
  "safetyCenter.description": "Essential safety information for buying through international marketplaces.",
  "disclaimer.title": "Disclaimer",
  "disclaimer.text": "This website is an independent informational resource. All information is provided for educational purposes only. We are not affiliated with AllChinaBuy or any buying agent platform. Always conduct your own research before making purchases.",
  "productShowcase.title": "Browse Featured Products",
  "productShowcase.description": "Explore our curated selection across every category. Click any item to visit the main store and complete your purchase.",
  "productShowcase.ctaTitle": "Want to see more?",
  "productShowcase.ctaDesc": "Visit the full store for thousands more products across all categories.",
  "productShowcase.ctaButton": "Visit Full Store",
  "productShowcase.buyNow": "Buy Now"
};